import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import ChatTextMessage from "@/components/chat/chatContainer/ChatTextMessage/ChatTextMessage.vue";
import ChatCallMessage from "@/components/chat/chatContainer/ChatCallMessage/ChatCallMessage.vue";
import {
  getIsMessageTextType,
  getIsMessageCallType,
  getIsMessageAudioType,
} from "@/utils/message";
import { Message } from "@/store/chats/types";
import ChatAudioMessage from "../ChatAudioMessage/ChatAudioMessage.vue";
import ChatFriendRequestMessage from "../ChatFriendRequestMessage/ChatFriendRequestMessage.vue";
import { computed } from "vue";

interface ChatMessageProps {
  message: Message;
  index: number;
  visibleMessages: Message[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatMessage',
  props: {
    message: {},
    index: {},
    visibleMessages: {}
  },
  setup(__props: any) {

const props = __props;

const commonProps = computed(() => ({
  index: props.index,
  visibleMessages: props.visibleMessages,
}));

return (_ctx: any,_cache: any) => {
  return (_unref(getIsMessageTextType)(_ctx.message))
    ? (_openBlock(), _createBlock(ChatTextMessage, _mergeProps({ key: 0 }, commonProps.value, { message: _ctx.message }), null, 16, ["message"]))
    : (_unref(getIsMessageCallType)(_ctx.message))
      ? (_openBlock(), _createBlock(ChatCallMessage, _mergeProps({ key: 1 }, commonProps.value, { message: _ctx.message }), null, 16, ["message"]))
      : (_unref(getIsMessageAudioType)(_ctx.message))
        ? (_openBlock(), _createBlock(ChatAudioMessage, _mergeProps({ key: 2 }, commonProps.value, { message: _ctx.message }), null, 16, ["message"]))
        : (_openBlock(), _createBlock(ChatFriendRequestMessage, _mergeProps({ key: 3 }, commonProps.value, { message: _ctx.message }), null, 16, ["message"]))
}
}

})